module.exports = __webpack_public_path__ + "static/media/logo.3646fa27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo.svg
// module id = 83
// module chunks = 0